<template>
  <div>
    <Row>
      <Form ref="queryMaintenanceForm" :model="query" :label-width="70"  label-position="right" inline class="index-query-form">
        <!--<Date-picker :value="query.maintenanceTime" type="datetime" @on-change="setTimeFormat"
                     :placeholder="this.$t('property.maintenance.maintenanceTime.holder')"></Date-picker>-->
        <Input
          v-model="query.maintenanceTime"
          placeholder="请输入时间"
          style="width:150px;margin-right: 10px;"
        />
        <Form-item :label-width="0">
            <span @click="handleSearch" style="margin: 0 10px;"><Button type="primary" >{{$t('searchText')}}</Button></span>
            <Button @click="resetSearchForm" type="default" >{{$t('resetText')}}</Button>
        </Form-item>
        <Button @click="openMaintenanceDrawer()" type="primary" style="margin-right: 10px;float:right" >{{$t('newText')}}</Button>
      </Form>
    </Row>
    <Row v-loading="page.loading" class="margin-top-10  searchable-table-con1"  style="width:100%;">
      <Table ref="maintenanceTable" :columns="columns" stripe border :data="page.data" @on-sort-change="handlePageSortChange"></Table>
      <Row v-if="page.total>0" type="flex" justify="space-between" align="middle" >
        <div>
          <Select v-model="batchOperate.action" placeholder="请选择" style="width:120px;margin-right: 10px;">
            <Option v-for="item in batchOperate.options" :key="item.value" :label="item.label" :value="item.value"></Option>
          </Select>
          <Button type="primary" :disabled="this.batchOperate.action=='' || $refs.maintenanceTable.getSelection().length == 0" :loading="batchOperate.submiting" @click="handleBatchOperate">{{ batchOperate.submiting ? '提交中 ...' : '确 定' }}</Button>
        </div>
        <Page :current="page.current" :total="page.total"  :page-size="page.size" @on-change="handlePageChange" show-elevator show-total style="padding: 10px;"></Page>
      </Row>
    </Row>
    <el-drawer ref="maintenanceDrawer" :title="this.$t('drawer.title')[maintenanceDrawer.type]" :visible.sync="maintenanceDrawer.visible" direction="rtl" size="40%" custom-class="right-drawer">
      <div class="right-drawer__content">
        <maintenance-form ref="maintenanceForm"/>
        <div class="right-drawer__footer" v-if="maintenanceDrawer.type!='detail'">
          <Button type="primary" @click="handleSubmit()" :loading="maintenanceDrawer.submiting">{{ maintenanceDrawer.submiting ? '提交中 ...' : '保 存' }}</Button>
          <Button @click="maintenanceDrawer.visible=false">取 消</Button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script type="text/jsx">
import Vue from 'vue';

import api from '@/api'
import mixin from '@/libs/mixins/Index'

import MaintenanceForm from '@/views/property/maintenance/components/Form.vue';
Vue.component('maintenance-form', MaintenanceForm);

export default {
  dictParams: ['deviceType'],
  name: 'aip-property-maintenance-index',
  mixins:[mixin],
  data () {
    return {
      query:{
        name:'',
        maintenanceTime:'',
        maintenanceType:''
      },
      page:{
         size: 10,
         current: 1,
         total: 0,
         sort: "id_desc",
         loading:false,
         data:[]
      },
      maintenanceDrawer:{
        action:'add',
        visible: false,
        submiting:false
      },
      batchOperate:{
        action:'',
        submiting:false,
        options:[
          {value:'handleBatchRemove',label:'批量删除'}
        ]
      }
    }
  },
  methods: {
    setTimeFormat(str, date){
      console.log(str)
      var datetime =  new Date(str);
      this.maintenance.maintenanceTime = str;
      // console.log(datetime);
    },
    handleBatchOperate(){
      let records = this.$refs.maintenanceTable.getSelection()
      if (records.length == 0) {
        this.$Message.warning(this.$t('errorText'))
        return;
      }
      this[this.batchOperate.action](records)
    },
    handleSearch(){
      this.page.loading = true;
      api.property.Maintenance.query(this.query,this.page)
        .then(data=>{
            this.page =  Object.assign(this.page,data);
            this.page.loading = false;
        }).catch(error=> this.page.loading = false)
    },
    openMaintenanceDrawer(maintenance){
      this.maintenanceDrawer.visible = true
      this.maintenanceDrawer.type = maintenance ? maintenance.type : 'add'
      this.$nextTick(()=>{
          if(maintenance){
              this.$refs['maintenanceForm'].getMaintenance(maintenance.id,maintenance.type)
          }else{
            this.$refs['maintenanceForm'].handleReset()
          }
      })
    },
    handleSubmit(){
        this.maintenanceDrawer.submiting = true;
        this.$refs.maintenanceForm.handleSubmit(
          data=>{
            this.maintenanceDrawer.submiting = false;
            this.handleSearch();
            setTimeout(() => this.maintenanceDrawer.visible=false, 1000);
          },
          ()=>{
            this.maintenanceDrawer.submiting = false;
          }
        )
    },
    deleteMaintenance(id){
      api.property.Maintenance.remove(id)
                            .then(response=> {
                                this.$Message.success(this.$t('successText'))
                                this.handleSearch()
                            }).catch(error=> console.log(error))
    },
    handleBatchRemove(rows){
      this.batchOperate.submiting = true
      Promise.all(rows.map(item=>api.property.Maintenance.remove(item.id)))
          .then(res => {
            this.batchOperate.submiting = false;
            this.handleSearch()
          }).catch(e=> {
            this.batchOperate.submiting = false
            this.handleSearch()
          })
    }
  },
  computed: {
    columns () {
      return [
          {key: 'id', width: 60, fixed:'left',type:'selection'},
          {key: 'maintenanceType',
            align:'left',
            minWidth: 120,
            fixed:'left',
            title:  this.$t('property.maintenance.maintenanceType.label'),
            render: (h, params) => {
              let str = '';
              for (let i = 0; i < this.dict.deviceType.length; i++) {
                if (params.row.maintenanceType == this.dict.deviceType[i].dictKey){
                  str = this.dict.deviceType[i].dictValue
                  return  <div>{str}</div>
                }
              }
            }},
          {key: 'maintenanceTime', align: 'center', width:170, title: this.$t('property.maintenance.maintenanceTime.label'),},
          {key: 'maintenancePeople',
            align:'left',
            minWidth: 120,
            title:  this.$t('property.maintenance.maintenancePeople.label'),
            render: (h, params) => {
              let json = JSON.stringify(params.row.employees.name);
              let str = json.substring(1,json.length-1);
              return <div>{str}</div>
            }
          },
          {key: 'maintenanceContent', align:'left',minWidth: 120, title:  this.$t('property.maintenance.maintenanceContent.label')},
          {key: 'maintenanceMoney', align:'left',minWidth: 120, title:  this.$t('property.maintenance.maintenanceMoney.label')},
        {
          title: this.$t('operateText'),
          align: 'center',
          width: 140,
          fixed:"right",
          key: 'handle',
          render: (h, params)=>{
            return <div style="display: flex;justify-content: space-around;">
              <a href="javascript:void(0);" onClick={()=>this.openMaintenanceDrawer({ id: params.row.id ,type:'detail'})}>{this.$t('detailText')}</a>
              <a href="javascript:void(0);" onClick={()=>this.openMaintenanceDrawer({ id: params.row.id ,type:'edit' })}>{this.$t('editText')}</a>
              <Poptip confirm={true} title={this.$t('deletePopTip')} transfer={true}
                      onOn-ok={()=>this.deleteMaintenance(params.row.id)}>
                <a href="javascript:void(0);">{this.$t('deleteText')}</a>
              </Poptip>
            </div>
          }
        }
      ]
    }
  }
}
</script>
